import React, { useEffect, useState } from 'react';
import Badge from '../Components/Badge1';
import moment from 'moment';
import { Tag } from '../Models';
import { MicrophoneIcon } from '@heroicons/react/outline';
import { shakespeare } from './content';
import { useIntercom } from 'react-use-intercom';

type Transcript = { text: string; timestamp: number; tags: Tag[] };

type Note = { timestamp: number; text: string; tags: Tag[] };

function Logo() {
  return (
    <svg
      width="219"
      height="22"
      viewBox="0 0 219 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M37.5577 9.9998C37.5577 7.09071 35.9247 5.45435 33.2031 5.45435C31.0259 5.45435 29.9373 6.36344 29.3929 7.27253C29.3929 6.72707 29.3929 6.18162 29.2115 5.81798H25.7642C25.7642 6.54525 25.7642 7.63616 25.7642 8.72707V17.0907H29.3929V11.2725C29.3929 9.27253 30.1187 7.9998 31.7516 7.9998C33.3846 7.9998 33.9289 9.09071 33.9289 10.3634V16.7271H37.5577V9.9998Z"
          fill="#1D1029"
        />
        <path
          d="M52.7985 11.2725C52.7985 8.54519 50.8027 5.27246 46.4482 5.27246C42.2751 5.27246 39.9164 8.18155 39.9164 11.2725C39.9164 14.3634 42.0936 17.2725 46.2667 17.2725C50.4398 17.2725 52.7985 14.727 52.7985 11.2725ZM46.2667 7.99973C48.2626 7.99973 49.1697 9.6361 49.1697 11.2725C49.1697 12.9088 48.2626 14.5452 46.4482 14.5452C44.6338 14.5452 43.5452 13.0906 43.5452 11.2725C43.5452 9.6361 44.4523 7.99973 46.2667 7.99973Z"
          fill="#1D1029"
        />
        <path
          d="M61.6889 16.7269V14.3633C61.3261 14.3633 60.9632 14.3633 60.7818 14.3633C59.6931 14.3633 59.5117 13.9996 59.5117 12.9087V8.18146H62.0518V5.63601H59.5117V2.36328H55.8829V5.63601H53.8871V8.18146H55.8829V13.4542C55.8829 15.636 56.6087 16.9087 59.5117 16.9087C60.2374 17.0906 61.1446 16.9087 61.6889 16.7269Z"
          fill="#1D1029"
        />
        <path
          d="M75.1155 13.8179V9.45428C75.1155 7.6361 74.3898 5.27246 69.4909 5.27246C64.9549 5.27246 64.0477 7.45428 64.0477 8.90882H67.6765C67.858 8.18155 68.2208 7.6361 69.6723 7.6361C71.3053 7.6361 71.6682 8.36337 71.6682 9.27246V9.6361H69.3095C66.0436 9.6361 63.5034 10.5452 63.5034 13.4543C63.5034 15.2725 64.7735 17.0906 67.858 17.0906C70.0352 17.0906 71.3053 16.5452 71.8496 15.4543C71.8496 15.8179 71.8496 16.5452 72.031 16.727H75.2969C75.2969 16.727 75.1155 15.2725 75.1155 13.8179ZM71.6682 12.1816C71.6682 13.8179 70.761 14.727 68.7651 14.727C67.4951 14.727 66.9508 14.1816 66.9508 13.4543C66.9508 12.5452 67.6765 11.9997 69.4909 11.9997C70.761 11.9997 71.4867 11.9997 71.6682 12.1816Z"
          fill="#1D1029"
        />
        <path
          d="M91.0821 11.0907C91.0821 7.81796 88.7234 5.45432 85.6389 5.45432C83.4617 5.45432 82.5545 6.36341 81.8287 6.90887V0.727051H78.2V13.2725C78.2 14.5452 78.2 15.4543 78.2 17.0907H81.6473C81.6473 16.9089 81.6473 16.1816 81.6473 15.818C82.1916 16.5452 83.0988 17.4543 85.2761 17.4543C88.3605 17.2725 91.0821 14.9089 91.0821 11.0907ZM81.6473 11.2725C81.6473 9.45432 82.5545 8.1816 84.5503 8.1816C86.5461 8.1816 87.2719 9.63614 87.2719 11.2725C87.2719 13.0907 86.3647 14.5452 84.3689 14.5452C82.7359 14.3634 81.6473 13.0907 81.6473 11.2725Z"
          fill="#1D1029"
        />
        <path d="M97.0696 0.727051H93.4408V16.9089H97.0696V0.727051Z" fill="#1D1029" />
        <path
          d="M108.319 15.2726L112.129 5.63623H108.5C107.049 9.99987 106.141 12.909 105.779 13.9999C105.597 13.2726 104.69 10.5453 102.876 5.63623H99.0653L104.146 17.2726C103.601 18.3635 103.238 18.909 101.605 18.909C101.243 18.909 101.061 18.909 100.517 18.909V21.818C100.88 21.818 101.787 21.9999 102.331 21.9999C105.779 21.9999 106.323 20.3635 108.319 15.2726Z"
          fill="#1D1029"
        />
        <path
          d="M18.0995 2.89272e-10H2.54569C1.87294 -1.01138e-05 1.22755 0.265203 0.750541 0.737683C0.273533 1.21016 0.00369638 1.85149 0 2.52152V15.3241C0.00367324 15.9954 0.27306 16.6382 0.749674 17.1129C1.22629 17.5876 1.87166 17.8559 2.54569 17.8596H14.4069C16.059 17.8559 17.6421 17.1996 18.809 16.0348C19.9759 14.87 20.6312 13.2918 20.6312 11.6463V2.52152C20.6312 1.85277 20.3645 1.21141 19.8897 0.738535C19.4149 0.265659 18.771 2.89272e-10 18.0995 2.89272e-10V2.89272e-10ZM19.2605 2.52152V4.17931H6.85376V1.3931H18.0436C18.1983 1.38562 18.3531 1.40908 18.4986 1.46209C18.6441 1.5151 18.7775 1.59659 18.8909 1.70175C19.0043 1.80691 19.0955 1.93362 19.1589 2.07441C19.2224 2.21521 19.2569 2.36723 19.2605 2.52152ZM1.38474 8.21931V5.4331H5.46902V8.21931H1.38474ZM5.46902 9.61241V12.3011H1.38474V9.59848L5.46902 9.61241ZM6.86775 5.50276H19.2745V8.28896H6.85376L6.86775 5.50276ZM2.54569 1.3931H5.46902V4.17931H1.38474V2.52152C1.39205 2.21971 1.51757 1.93271 1.73451 1.72186C1.95144 1.511 2.24257 1.39301 2.54569 1.3931ZM1.38474 15.3241V13.6803H5.46902V16.4665H2.54569C2.24019 16.4665 1.947 16.3466 1.72968 16.1327C1.51236 15.9189 1.38842 15.6284 1.38474 15.3241ZM14.4069 16.4804H6.85376V13.6942H13.7775V12.3011H6.85376V9.59848H19.2605V11.5767C19.2568 12.8576 18.7442 14.0851 17.8348 14.9908C16.9254 15.8966 15.693 16.4071 14.4069 16.4107V16.4804Z"
          fill="#382152"
        />
        <path
          d="M15.1338 10.2391C14.8626 10.2391 14.5941 10.2925 14.3437 10.3963C14.0933 10.5001 13.8661 10.6522 13.6749 10.8438C13.4838 11.0354 13.3327 11.2628 13.2302 11.5129C13.1277 11.763 13.0758 12.0308 13.0777 12.3009V17.7897H14.4065C16.0586 17.786 17.6417 17.1298 18.8086 15.965C19.9755 14.8002 20.6308 13.2219 20.6308 11.5765V10.1833L15.1338 10.2391Z"
          fill="#855FA8"
        />
      </g>
      <path
        d="M119.763 8.86364H118.117V8.17756C118.117 7.50142 118.395 7.13352 119.121 7.13352C119.429 7.13352 119.648 7.20312 119.787 7.24787L120.135 6.04474C119.927 5.9652 119.494 5.84091 118.893 5.84091C117.684 5.84091 116.625 6.54688 116.625 7.97869V8.86364H115.447V10.0568H116.625V16.5H118.117V10.0568H119.763V8.86364ZM123.652 16.6541C125.805 16.6541 127.212 15.0781 127.212 12.7166C127.212 10.3402 125.805 8.7642 123.652 8.7642C121.499 8.7642 120.092 10.3402 120.092 12.7166C120.092 15.0781 121.499 16.6541 123.652 16.6541ZM123.657 15.4062C122.25 15.4062 121.594 14.1783 121.594 12.7116C121.594 11.25 122.25 10.0071 123.657 10.0071C125.054 10.0071 125.71 11.25 125.71 12.7116C125.71 14.1783 125.054 15.4062 123.657 15.4062ZM128.311 16.5H129.798V11.8366C129.798 10.8374 130.568 10.1165 131.622 10.1165C131.93 10.1165 132.278 10.1712 132.398 10.206V8.78409C132.249 8.7642 131.955 8.74929 131.766 8.74929C130.871 8.74929 130.106 9.25639 129.827 10.0767H129.748V8.86364H128.311V16.5Z"
        fill="#382152"
      />
      <g clipPath="url(#clip1)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M204.217 7.79799C204.515 8.26754 204.613 8.80177 204.645 9.40235L204.688 10.2029V15.8005L204.731 16.6018C204.818 17.9105 205.876 18.8782 207.323 18.9605L208.198 19V10.2029L208.241 9.40235C208.277 8.80849 208.374 8.26418 208.677 7.79127C208.986 7.3062 209.43 6.90376 209.963 6.62435C210.497 6.34493 211.102 6.19838 211.717 6.1994C212.333 6.20042 212.937 6.34898 213.469 6.63017C214.002 6.91135 214.444 7.31526 214.751 7.80135C215.049 8.2709 215.142 8.8152 215.178 9.40235L215.222 10.2003V15.8005L215.265 16.6018C215.355 17.9173 216.406 18.8849 217.857 18.9605L218.732 19V9.40235C218.732 7.70523 217.993 6.07757 216.676 4.87729C215.36 3.677 213.574 3.00235 211.712 3.00168C210.715 3.00072 209.73 3.19362 208.822 3.56749C207.914 3.94136 207.103 4.48758 206.445 5.16968C205.787 4.48785 204.976 3.94176 204.068 3.56778C203.16 3.1938 202.175 3.00053 201.178 3.00084C199.72 3.00084 198.367 3.40403 197.246 4.10038C196.563 3.40487 195.033 3.00084 194.154 3.00084V19L195.033 18.9605C196.502 18.8723 197.564 17.9307 197.621 16.6018L197.668 15.8005V10.2029L197.711 9.40235C197.748 8.79841 197.84 8.26754 198.14 7.79463C198.449 7.30987 198.892 6.90752 199.425 6.62776C199.958 6.34801 200.563 6.20063 201.178 6.20034C201.794 6.20046 202.399 6.34813 202.932 6.62855C203.465 6.90896 203.908 7.31226 204.217 7.79799ZM144.125 18.9614L145.003 19H158.168L158.125 18.202C158.006 16.8866 156.984 15.9257 155.536 15.84L154.658 15.8005H146.76L157.29 6.1995L157.247 5.40235C157.179 4.0735 156.113 3.1134 154.658 3.04032L153.78 3.0042L140.614 3.00084L140.658 3.80135C140.773 5.10416 141.81 6.08526 143.246 6.16086L144.125 6.20034H152.023L141.493 15.8013L141.536 16.6018C141.623 17.9206 142.667 18.8757 144.125 18.9605V18.9614ZM190.709 5.34272C191.524 6.08553 192.17 6.96743 192.612 7.93804C193.053 8.90865 193.28 9.94897 193.28 10.9996C193.28 12.0502 193.053 13.0905 192.612 14.0611C192.17 15.0317 191.524 15.9136 190.709 16.6564C189.062 18.1563 186.829 18.9988 184.501 18.9988C182.172 18.9988 179.94 18.1563 178.293 16.6564C174.865 13.5325 174.865 8.46661 178.293 5.34272C179.107 4.60015 180.074 4.01107 181.138 3.6091C182.202 3.20714 183.343 3.00017 184.495 3C185.649 2.99927 186.792 3.20588 187.858 3.60801C188.924 4.01014 189.893 4.5999 190.709 5.34356V5.34272ZM188.225 7.60815C189.212 8.50863 189.767 9.72953 189.767 11.0025C189.767 12.2755 189.212 13.4964 188.225 14.3969C187.237 15.2967 185.897 15.8021 184.501 15.8021C183.104 15.8021 181.764 15.2967 180.776 14.3969C179.789 13.4964 179.235 12.2755 179.235 11.0025C179.235 9.72953 179.789 8.50863 180.776 7.60815C181.764 6.70835 183.104 6.20291 184.501 6.20291C185.897 6.20291 187.237 6.70835 188.225 7.60815ZM166.074 3C167.226 3.00028 168.367 3.20738 169.431 3.60949C170.495 4.0116 171.462 4.60084 172.276 5.34356C175.705 8.46661 175.705 13.5334 172.276 16.6564C170.629 18.1563 168.397 18.9988 166.068 18.9988C163.74 18.9988 161.507 18.1563 159.86 16.6564C156.433 13.5325 156.433 8.46661 159.86 5.34272C160.675 4.60015 161.642 4.01107 162.706 3.6091C163.77 3.20714 164.911 3.00017 166.063 3H166.074ZM169.793 7.60647C170.78 8.50698 171.335 9.72807 171.335 11.0013C171.335 12.2745 170.78 13.4955 169.793 14.3961C168.805 15.2959 167.465 15.8013 166.068 15.8013C164.672 15.8013 163.332 15.2959 162.344 14.3961C161.357 13.4956 160.802 12.2747 160.802 11.0017C160.802 9.72869 161.357 8.50779 162.344 7.60731C163.332 6.70751 164.672 6.20207 166.068 6.20207C167.465 6.20207 168.805 6.70751 169.793 7.60731V7.60647Z"
          fill="#277AFB"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="112.129" height="22" fill="white" />
        </clipPath>
        <clipPath id="clip1">
          <rect width="78.1176" height="16" fill="white" transform="translate(140.614 3)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default function Zoom(): JSX.Element {
  const projects = [
    {
      transcript: [],
      tags: [
        { name: 'quote', color: '#FFD57E' },
        { name: 'observation', color: '#A0E4CA' },
        { name: 'needs', color: '#D4C2F4' },
        { name: 'pain points', color: '#FAB6B6' },
      ],
      notes: [],
    },
  ];

  const project = projects[0];

  const [notes, setNotes] = useState<Note[]>(project.notes as Note[]);
  const [transcription, setTranscription] = useState<Transcript[]>(
    project.transcript as Transcript[]
  );
  const [noteValue, setNoteValue] = useState('');

  type Interval = {
    start: number;
    stop: number | null;
    tag?: Tag;
  };

  const [citations, setCitations] = useState<Interval[]>([]);

  const [cursor, setCursor] = useState(0);

  const [isRecording, setIsRecording] = useState(false);

  const { shutdown } = useIntercom();

  shutdown();

  const startRecording = (tag?: Tag) => {
    if (isRecording) {
      return;
    }
    if (noteValue) {
      return;
    }
    setIsRecording(true);
    setCitations((prev) => [...prev, { start: Date.now(), stop: null, tag }]);
  };

  const stopRecording = () => {
    if (!isRecording) {
      return;
    }
    if (noteValue.trim()) {
      return;
    }
    setIsRecording(false);
    setCitations((prev) => {
      prev[prev.length - 1].stop = Date.now();
      return prev;
    });
  };

  const onClick = (tag?: Tag) => {
    if (!noteValue) {
      return;
    }

    setNotes([...notes, { timestamp: Date.now(), text: noteValue, tags: tag ? [tag] : [] }]);

    setNoteValue('');
  };

  const onMouseDown = (tag?: Tag) => {
    startRecording(tag);
  };

  const onMouseUp = () => {
    stopRecording();
  };

  const handleOnKeyDown = (e: any) => {
    switch (e.key) {
      case 'Enter':
        e.preventDefault();
        e.stopPropagation();
        if (!noteValue) {
          startRecording({ color: 'white' } as Tag);
        } else {
          onClick({ color: 'white' } as Tag);
        }
        break;
      default:
        if (e.altKey) {
          e.preventDefault();
          e.stopPropagation();
          const intKey = e.keyCode - 48;

          if (intKey > 0 && intKey < project.tags.length) {
            if (noteValue) {
              onClick(project.tags[intKey - 1]);
            } else {
              startRecording(project.tags[intKey - 1]);
            }
          }
        }
        break;
    }
  };

  const handleKeyUp = () => {
    stopRecording();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCursor((prev) => prev + 1);
      setTranscription((prev) => [
        ...prev,
        {
          text: shakespeare
            .split('\n')
            [cursor].replace('.', ' ')
            .replace(',', ' ')
            .replace(':', ' ')
            .replace(';', ' ')
            .replace(',', ' '),

          timestamp: Date.now(),
          tags: [],
        },
      ]);
    }, 2000);

    return () => clearInterval(interval);
  }, [transcription, cursor]);

  const sort = (x: Transcript | Note, y: Transcript | Note) => x.timestamp - y.timestamp;

  const timeline = [...notes, ...transcription].sort(sort);

  const inInterval = (value: number, min: number, max: number | null) => {
    return value >= min && (max === null || value < max);
  };

  const getColor = (note: Note) => {
    const citation = citations.find((x) => inInterval(note.timestamp, x.start, x.stop));
    return citation?.tag?.color ?? (note.tags?.length > 0 ? note.tags[0]?.color : null);
  };

  return (
    <div className="flex flex-col h-screen bg-gray-900 text-gray-400">
      <div className="bg-white p-3">
        <Logo />
      </div>
      <div className={'p-3 text-sm font-bold text-gray-300 sticky border-b border-gray-700'}>
        Notes
      </div>
      <div
        className="px-3 py-2 h-full flex overflow-y-auto"
        style={{
          flexDirection: 'column-reverse',
        }}
      >
        <div>
          {timeline.map((note, i) => {
            return (
              <div key={i} className={'text-sm pb-2'}>
                <span className={'text-gray-300 pr-2'}>
                  {moment(note.timestamp).format('HH:mm:ss')}
                </span>
                <div
                  style={{
                    color: getColor(note) ?? '',
                  }}
                >
                  {note.text}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="p-3 flex-col">
        <div>
          {isRecording && (
            <div className={'w-full flex justify-center'}>
              <MicrophoneIcon className={'w-6 h-6 text-red-500 mb-4 mt-2.5 animate-pulse'} />
            </div>
          )}
          <input
            autoFocus
            value={noteValue}
            onKeyDown={handleOnKeyDown}
            onKeyUp={handleKeyUp}
            onChange={(e) => setNoteValue(e.target.value)}
            className={
              'w-full bg-transparent text-sm border border-gray-700 p-3 mb-1 ' +
              (isRecording ? 'absolute -top-20' : '')
            }
            placeholder="Type notes here or hold a button to create and tag notes..."
            type="text"
          />
        </div>
        <button
          onMouseUp={(e) => onMouseUp()}
          onMouseDown={(e) => onMouseDown({ color: 'white' } as Tag)}
          className={'w-full m-0.5'}
          onClick={(e) => onClick({ color: 'white' } as Tag)}
        >
          <Badge name={'note (Enter)'} className={'w-full'} color={'Note'} />
        </button>
        {project.tags.map((tag, i) => (
          <button
            onMouseUp={(e) => onMouseUp()}
            onMouseDown={(e) => onMouseDown(tag)}
            key={i}
            className={'w-full m-0.5'}
            onClick={(e) => onClick(tag)}
          >
            <Badge
              name={tag.name + ` (Opt+${i + 1})`}
              className={'w-full text-center'}
              color={tag.color}
            />
          </button>
        ))}
      </div>
    </div>
  );
}
